exports.RestaurantProperties = {
    WixMenu:{
        MENU_VIEW:                  "wixmenu.menuview",
        WIDGETS_SHORTCUT:           "wixmenu.widgets.shortcut",
        WIDGETS_SPECIALS:           "wixmenu.widgets.specials",
        WIDGETS_OPENINGHOURS:       "wixmenu.widgets.openinghours",
        WIDGETS_PHONE:              "wixmenu.widgets.phone",
        WIDGETS_ADDRESS:            "wixmenu.widgets.address",
        WIDGETS_DESCRIPTION:        "wixmenu.widgets.description",
        WIDGETS_PRICE:              "wixmenu.widgets.price",
        WIDGETS_VARIATIONS:         "wixmenu.widgets.variations",
        WIDGETS_ICONS:              "wixmenu.widgets.icons",
        WIDGETS_PLACEHOLDER_IMAGES: "wixmenu.widgets.placeholderimages",
        WIDGETS_SECTION_IMAGES:     "wixmenu.widgets.sectionimages",
        WIDGETS_IMAGES_STYLE:       "wixmenu.widgets.imagesstyle",
        AUTOUPDATE:                 "wixmenu.autoupdate",
        PRICE_RANGE:                "wixmenu.priceRange"
    },
    WixRestaurant:{
        MENU_SAVED_ONCE:            "wixrestaurants.menusavedonce",
        BEEP_INTERVAL:              "wixrestaurants.beepInterval",
        ENABLE_UOU:                 "wixrestaurants.enableUou",
        CHAIN: {
            DEFAULT_DISPATCH_TYPE:  "wixrestaurants.chain.defaultDispatchType"
        },
        FUTURE_ORDERS: {
            NO_ASAP:                    "wixrestaurants.futureOrders.noAsap",
            SCHEDULE_AS_NEW_MINUTES:    "wixrestaurants.futureOrders.scheduleAsNewMinutes"
        }
    },
    Interested:{
        OLO:                        "interested.olo"
    },
    Design:{
        CLIENT_V2_0:                "design.client_v2_0"
    },
    OLO:{
        DEFAULT_DELIVERY:           "olo.defaultDelivery",
        QUANTITY_MODE:              "olo.quantityMode",
        INVENTORY_MODE:             "olo.inventoryMode",
        KITCHEN_REQUESTS_PLACEHOLDER: "olo.kitchenRequestsPlaceholder",
    },
    Products:{
        CALLCENTER:                 "products.?callcenter",
        IOS:                        "products.?ios",
        ANDROID:                    "products.?android"
    }
};

exports.CategoryProperties = {
    SYSTEMS_OLO:                    "systems.?OLO",
    REFS:                           "refs"
};

exports.AddressProperties = {
    ADDRESS_OVERRIDE:               "addressOverride"
};

exports.OrderProperties = {
    DELIVERED:                      "delivered"
}



//////////////////
// WEBPACK FOOTER
// ../node_modules/@wix/wixrest-properties/index.js
// module id = 265
// module chunks = 0